import {CclStatusEnum} from '../../../service/ccl-statistic/ccl-statistic-type';

export const FILTERABLE_CCL_STATUSES = [CclStatusEnum.synced, CclStatusEnum.sent, CclStatusEnum.actionNeeded];
